
import Card from 'card';

export default {
    init() {
        const form = document.getElementById('form-cart-payment');
        if (!form) return; 

        var card = new Card({
            form: form,
            container: '.card-wrapper',
            formSelectors: {
                numberInput: 'input[name="cardnumber"]',
                expiryInput: 'input[name="cc-exp"]',
                cvcInput: 'input[name="cvc"]',
                nameInput: 'input[name="ccname"]'
            },
            placeholders: {
                number: '•••• •••• •••• ••••',
                name: 'Nom',
                expiry: '••/••',
                cvc: '•••'
            },            
            messages: {
                validDate: 'expire\ndate',
                monthYear: 'mm/yy'
            }
        });
        
    },
    finalize() {
        $('#add_card').on('click', function(){
            $('.card-form').show();
            $('.card-list input').removeAttr('checked');
        });

        if ($('.card-list div').length === 0) {
            $('.card-form').show();
        }

        $('.card-list input').click(function(){
            $('.card-form').hide();
        });

        $('#form-cart-payment').on('submit', function(e) {
            
            $(this).find('button[type="submit"]')
            .attr('disabled', true)
            .html(`<svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                width="20px" height="20px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                <animateTransform attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="0.6s"
                    repeatCount="indefinite"/>
                </path>
                </svg>
            `)
        })
    },
  };
  

  


// WEBPACK FOOTER //
// ./assets/src/js/routes/invoice.js